import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import { DialogShow_2 } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";

import "../../../components/DataTable/DataTable.css";

import P214List from "./P214List";
import P214Search from "./P214Search";
import P215 from "../215/P215";

import ValidateService from "../../../components/ValidateService/ValidateService";
import { P214GetColumnList, P214GetDataList, P214UpdateData } from "../../../service/200/P214Service";
import { P215GetColumnList, P215GetDataList, P215UpdateData } from "../../../service/200/P215Service";
import { ZeroToNull } from "../../../utilities/NullUtil";

export default function P214() {
    const history = useHistory();
    const location = useLocation();
    const toast = useRef(null);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    const [dataTableA, setDataTableA] = useState([]);
    const [dataTableColA, setDataTableColA] = useState([]);
    const [keyListA, setKeyListA] = useState(["", ""]);

    const [dataTableB, setDataTableB] = useState([]);
    const [dataTableColB, setDataTableColB] = useState([]);
    const [keyListB, setKeyListB] = useState(["", ""]);

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [indexTab, setIndexTab] = useState(1);

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });
    const [show, setShow] = useState(false);

    useEffect(() => {
        setLoading(true);
        setTimeout(async () => {
            await Promise.all([onP214GetColumnList(), onP214GetDataList(), onP215GetColumnList(), onP215GetDataList()]);
            onTabActive();
        }, 10);

        setLoading(false);
    }, [searchData]);

    useEffect(() => {
        if (dataUserSession()) {
            if (!history.location.state) {
                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);

    const onTabActive = (list) => {
        if (location && location.pathname) {
            switch (location.pathname) {
                case "/215":
                    setIndexTab(1);
                    break;
                case "/214":
                default:
                    setIndexTab(0);
                    break;
            }
        }
        setShow(true);
    };

    const onP214GetColumnList = async () => {
        setLoading(true);
        await P214GetColumnList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('Hd ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let keyList = ["", ""];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            contractAmount: ZeroToNull(element.contractAmount),
                            contractUnit: ZeroToNull(element.contractUnit),
                            itemUnitPrice: ZeroToNull(element.itemUnitPrice),
                            index: index,
                        });

                        keyList.push(element.updateKey);
                        index++;
                    });

                    setKeyListA(keyList);
                    setDataTableA(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP214GetDataList = async () => {
        setLoading(true);
        await P214GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('col ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableColA(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP214UpdateData = async (dataReq) => {
        await P214UpdateData(dataReq).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data[0].statusText === "") {
                        if (res.data[0].statusCode === "C") {
                            setTextShow(`บันทึกสมบูรณ์ `);
                        } else if (res.data[0].statusCode === "E") {
                            setTextShow(`มีข้อผิดพลาด`);
                        }
                    } else {
                        setTextShow(`${res.data[0].statusText}`);
                    }
                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onP215GetColumnList = async () => {
        setLoading(true);
        await P215GetColumnList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let keyList = ["", ""];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            contractAmount: ZeroToNull(element.contractAmount),
                            contractUnit: ZeroToNull(element.contractUnit),
                            itemUnitPrice: ZeroToNull(element.itemUnitPrice),
                            index: index,
                        });

                        keyList.push(element.updateKey);
                        index++;
                    });

                    setKeyListB(keyList);
                    setDataTableB(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP215GetDataList = async () => {
        setLoading(true);
        await P215GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableColB(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP215UpdateData = async (dataReq) => {
        // console.log(dataReq);
        await P215UpdateData(dataReq).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data[0].statusText === "") {
                        if (res.data[0].statusCode === "C") {
                            setTextShow(`บันทึกสมบูรณ์ `);
                        } else if (res.data[0].statusCode === "E") {
                            setTextShow(`มีข้อผิดพลาด`);
                        }
                    } else {
                        setTextShow(`${res.data[0].statusText}`);
                    }
                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const submitForm = async (submitForm, page) => {
        if (submitForm && submitForm.length > 0) {
            setLoading(true);
            await Promise.all(
                submitForm.map(async (item) => {
                    if (page === 215) {
                        // console.log("p_supervisor_result_detail_update");
                        onP215UpdateData(item);
                    } else if (page === 214) {
                        // console.log("p_supervisor_route_memo_detail_update");
                        onP214UpdateData(item);
                    }
                })
            );

            await Promise.all([onP214GetColumnList(), onP214GetDataList(), onP215GetColumnList(), onP215GetDataList()]);

            setLoading(false);
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const goPage = (page) => {
        if (page) {
            history.push({
                pathname: page,
            });
        } else {
            history.push("/200");
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <P214Search data={searchData} data_A={dataTableColA} data_B={dataTableColB} goPage={goPage} indexTab={indexTab} />
                        <br />
                        {show && show === true ? (
                            <TabView activeIndex={indexTab} onTabChange={({ index }) => setIndexTab(index)}>
                                <TabPanel header={"กระดาษทด-เส้นทางที่ " + searchData.routeNo}>
                                    <P214List dataTable={dataTableA} dataCol={dataTableColA} keyListB={keyListA} searchData={searchData} goPage={goPage} submitForm={submitForm} />
                                </TabPanel>

                                <TabPanel header={"บันทึกผล-เส้นทางที่ " + searchData.routeNo}>
                                    <P215 dataTable={dataTableB} dataCol={dataTableColB} keyListB={keyListB} searchData={searchData} goPage={goPage} submitForm={submitForm} />
                                </TabPanel>
                            </TabView>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </>
    );
}
